import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addOrUpdateCarbonProgramFeatureFlagAdmin } from "services";

import { ADD_OR_UPDATE_CARBON_PROGRAM_FEATURE_FLAG, GET_CARBON_PROGRAM_FEATURE_FLAGS, GET_FARM_FEATURE_FLAGS } from "consts";

export const useAddOrUpdateCarbonProgramFeatureFlagAdmin = ({ programId }: { programId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_OR_UPDATE_CARBON_PROGRAM_FEATURE_FLAG],
    mutationFn: addOrUpdateCarbonProgramFeatureFlagAdmin,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_FEATURE_FLAGS, programId] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_FEATURE_FLAGS] });
    },
  });
};
